// Components
import React from 'react';

import Button from '@/common/components/atoms/Button/Button';

// Libs
import {
  CustomArrowDefaultProps,
  CustomArrowPropTypes,
} from './CustomArrow.proptypes';
// TODO: check the others CustomArrow in scopes
const CustomArrow = ({ children, className, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Button {...props} className={className} data-qa-id="custom-arrow">
    {children}
  </Button>
);

CustomArrow.defaultProps = {
  ...CustomArrowDefaultProps,
};

CustomArrow.propTypes = {
  ...CustomArrowPropTypes,
};

export default CustomArrow;
